import styles from './CorrectionRequestModal.module.css';
import api from '../../../../../api';
import { useState } from 'react';

const CORRECTION_TYPES = [
  { value: 'wrong_place',     label: '게시글과는 다른 장소예요.' },
  { value: 'need_update',     label: '장소 정보의 최신화가 필요해요.' },
  { value: 'wrong_category',  label: '장소 이름/카테고리/태그가 이상해요.' },
  { value: 'wrong_period',    label: '기간 정보가 틀렸어요/없어요.' }
];

const CorrectionRequestModal = ({ setHotpleModalPage, originalHotple, marginTop }) => {
  const [type, setType] = useState('');
  const [isPatching, setIsPatching] = useState(false);

  const handleBack = () => setHotpleModalPage(0);

  const requestCorrection = async () => {
    if (!type || isPatching) return;

    if (type=='wrong_category' || type=='wrong_period'){
      setHotpleModalPage(11);
      return;
    }

    try {
      setIsPatching(true);
      await api.post('/hotple/correction', {
        hotple_id: originalHotple.hotple_id,
        type
      });
      setHotpleModalPage(0);
      alert('오류 제보 감사합니다 :)\n\n확인 후 정정하도록 하겠습니다!');
      setIsPatching(false);
    } catch (error) {
      console.error('Error requestCorrection:', error);
      alert('정정 요청 중 오류가 발생했습니다. 다시 시도해주세요.');
      setHotpleModalPage(0);
      setIsPatching(false);
    }
  };

  return (
    <div
      className={styles.reviewmodal4}
      style={{
        maxHeight: `calc(100dvh - ${marginTop + 24}px)`,
        marginTop: `${marginTop}px`
      }}
    >
      <div className={styles.mainframe}>
        <div className={styles.headerframe}>
          <b className={styles.b}>어떤 정보가 잘못되었나요?</b>
        </div>
        <form className={styles.radioGroup}>
          {CORRECTION_TYPES.map(item => (
            <label key={item.value} className={styles.radioLabel}>
              <input
                type="radio"
                name="correctionType"
                value={item.value}
                checked={type === item.value}
                onChange={() => setType(item.value)}
                className={styles.radioInput}
              />
              <span className={styles.radioText}>{item.label}</span>
            </label>
          ))}
        </form>
      </div>

      <div className={styles.buttonFrame}>
        <div className={styles.backButton} onClick={handleBack}>
          <div className={styles.nametext}>돌아가기</div>
        </div>
        <button
          type="button"
          className={!type || isPatching ? styles.addButtonDisabled : styles.addButton}
          onClick={requestCorrection}
          disabled={!type || isPatching}
        >
          <div className={styles.nametext}>정정 요청하기</div>
        </button>
      </div>
    </div>
  );
};

export default CorrectionRequestModal;
